import { defineMessages } from 'react-intl'

export default defineMessages({
    buyoutsTitle: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.buyoutsTitle',
        defaultMessage: 'Usage details',
    },
    buyoutDelete: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.buyoutDelete',
        defaultMessage: 'Delete',
    },
    tableHeadSpotQuantity: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.tableHeadSpotQuantity',
        defaultMessage: 'Quantity',
    },
    tableHeadMedia: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.tableHeadMedia',
        defaultMessage: 'Media',
    },
    tableHeadUsage: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.tableHeadUsage',
        defaultMessage: 'Airing time',
    },
    tableHeadTerritoryMarket: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.tableHeadTerritoryMarket',
        defaultMessage: 'Territory/Market',
    },
    tableHeadCost: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.tableHeadCost',
        defaultMessage: 'Total Cost',
    },
    tableHeadPrice: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.tableHeadPrice',
        defaultMessage: 'Total Price',
    },
    addBuyout: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.addBuyout',
        defaultMessage: '+ Add Usage',
    },
    noData: {
        id: 'containers.AuditionScopePage.components.AddVersion.components.BuyoutsTable.noData',
        defaultMessage: 'No usages added',
    }
})
